import { render } from "./ListNavMenu.vue?vue&type=template&id=3e5c84a1"
import script from "./ListNavMenu.vue?vue&type=script&lang=js"
export * from "./ListNavMenu.vue?vue&type=script&lang=js"
script.render = render

export default script